import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

export type ExpertProfileFragmentFragment = {
  __typename?: 'ExpertDataHubType';
  firstName?: string | null;
  lastName?: string | null;
  photoFileId?: string | null;
  cvId?: string | null;
  jobPositionName?: string | null;
  jobPositionId?: string | null;
  rateDesired?: number | null;
  workType?: Types.WorkModeEnum | null;
  location?: string | null;
  availability?: Types.ExpertAvailabilityEnum | null;
  noticeLength?: number | null;
  firstLanguageId?: string | null;
  isOnlyFirstLanguage?: boolean | null;
  isMainRoleExperience?: boolean | null;
  isOtherRolesExperience?: boolean | null;
  avatarUrl?: string | null;
  linkedInUrl?: string | null;
  phoneNumber?: string | null;
  isExtractionAcknowledged: boolean;
  cv?: {
    __typename?: 'ExpertCvType';
    id: string;
    name: string;
    mimeType: string;
    size: number;
    createdAt: any;
  } | null;
  tags: Array<{ __typename?: 'ExpertTagType'; id: string; weight: number }>;
  manuallyAddedTags: Array<{ __typename?: 'ExpertTagType'; id: string; weight: number }>;
  languages: Array<{
    __typename?: 'ExpertLanguageType';
    languageId: string;
    level: Types.LanguageLevelEnum;
  }>;
  workHistory: Array<{
    __typename?: 'ExpertWorkHistoryHubType';
    id: string;
    jobPositionName: string;
    jobPositionId: string;
    companyName?: string | null;
    tagsIds: Array<string>;
    mainTechnologyIds: Array<string>;
    dateStart: any;
    dateEnd?: any | null;
    isCurrentJob: boolean;
    description?: string | null;
  }>;
  education: Array<{
    __typename?: 'ExpertEducationHubType';
    id: string;
    schoolName: string;
    fieldOfStudyPL?: string | null;
    dateFrom: any;
    dateTo?: any | null;
    isCurrent?: boolean | null;
  }>;
  certificates: Array<{
    __typename?: 'ExpertCertificateHubType';
    id: string;
    name: string;
    issuer?: string | null;
    url?: string | null;
    issueDate?: any | null;
  }>;
};

export const ExpertProfileFragmentFragmentDoc = gql`
  fragment ExpertProfileFragment on ExpertDataHubType {
    firstName
    lastName
    photoFileId
    cvId
    cv {
      id
      name
      mimeType
      size
      createdAt
    }
    jobPositionName
    jobPositionId
    rateDesired
    workType
    location
    availability
    noticeLength
    tags {
      id
      weight
    }
    manuallyAddedTags {
      id
      weight
    }
    languages {
      languageId
      level
    }
    firstLanguageId
    isOnlyFirstLanguage
    workHistory {
      id
      jobPositionName
      jobPositionId
      companyName
      tagsIds
      mainTechnologyIds
      dateStart
      dateEnd
      isCurrentJob
      description
    }
    isMainRoleExperience
    isOtherRolesExperience
    education {
      id
      schoolName
      fieldOfStudyPL
      dateFrom
      dateTo
      isCurrent
    }
    certificates {
      id
      name
      issuer
      url
      issueDate
    }
    avatarUrl
    linkedInUrl
    phoneNumber
    isExtractionAcknowledged
  }
`;
